export default __webpack_public_path__ + "static/media/a024-startup-2.e520ab21.svg";